import { EFlags } from '@feathr/blackbox';

export const flagLabelMap = new Map<EFlags, string>([
  [EFlags.bypassMX, 'Bypass MX'],
  [EFlags.creditCardConvenienceFeeAccepted, 'Credit Card Convenience Fee Accepted'],
  [EFlags.csmManager, 'CSM Manager'],
  [EFlags.emUID2, 'Email Mapping Transition to UID2'],
  [EFlags.hasBlackbaudRaisersEdge, 'Has Blackbaud Raisers Edge'],
  [EFlags.hasGoogleAds, 'Has Google Ads'],
  [EFlags.hasImis, 'Has IMIS'],
  [EFlags.hasMultiConversions, 'Has Multi Conversions'],
  [EFlags.locales, 'Locales'],
  [EFlags.minBudget, 'Min Budget'],
  [EFlags.monetization, 'Monetization'],
  [EFlags.noMaxBudget, 'No Max Budget'],
  [EFlags.pinpoint, 'Pinpoint'],
  [EFlags.pinpointSendAllEmails, 'Pinpoint Send All Emails'],
  [EFlags.showAllAffinityAudiences, 'Show All Affinity Audiences'],
  [EFlags.showConversionsSettingsV2, 'Show Conversions Settings V2'],
  [EFlags.showDripCampaigns, 'Show Drip Campaigns'],
  [EFlags.showDripBulkEnroll, 'Show Drip Bulk Enroll'],
  [EFlags.showForms, 'Show Forms'],
  [EFlags.showUsageMetrics, 'Show Usage Metrics'],
  [EFlags.showUsersAndRolesV2, 'Show Users and Roles V2'],
  [EFlags.showCampaignRecommendations, 'Show Campaign Recommendations'],
  [EFlags.showOnboarding, 'Show Onboarding'],
  [EFlags.zapier, 'Zapier'],
  [EFlags.enforceOnboarding, 'Enforce Onboarding'],
  [EFlags.showPixlPlus, 'Show Pixl Plus'],
]);
